import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle, testid }) {
  return (
    <section data-testid={testid} className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-hero-radial opacity-70" />
      <div className="absolute inset-0 ring-grid opacity-20" />
      <div className="container-zx relative z-10">
        {overline && <div className="overline mb-3">{overline}</div>}
        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-white max-w-4xl leading-[1.05]"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.08 }}
            className="mt-5 text-base sm:text-lg text-ink-200 max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
